const title = '明商道'
const getTitle = function(til) {
  console.log(til)
  // let allTitle = til + ' - ' + title
  let allTitle = title
  return allTitle
}
export default getTitle
